module.exports = __webpack_public_path__ + "img/dribble.3b6933ea.svg";